import { useState } from "react";
import { Button, Input } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

const { TextArea } = Input;

interface ChatInputProps {
  isNewSession?: boolean;
  handleSearch: (prompt: string) => void;
  isLoading?: boolean;
}

export default function ChatInput({
  isNewSession = false,
  handleSearch,
  isLoading = false,
}: ChatInputProps) {
  const [currentPrompt, setCurrentPrompt] = useState("");

  const isSubmitDisabled =
    !currentPrompt.trim() || (isLoading && !isNewSession);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentPrompt(e.target.value);
  };

  const submitPrompt = () => {
    const trimmed = currentPrompt.trim();
    if (!isSubmitDisabled) {
      handleSearch(trimmed);
      setCurrentPrompt("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submitPrompt();
    }
  };

  return (
    <div className="flex items-end relative rounded-[10px]">
      <TextArea
        data-testid="ask-vivo-prompt-input"
        value={currentPrompt}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="How can I help you?"
        className="searchbar-input w-full py-3 px-4 pr-12 text-base text-[#2B4752] rounded-lg overflow-y-auto hide-scrollbar"
        autoSize={{ minRows: 1, maxRows: 5 }}
        disabled={isLoading && !isNewSession}
      />
      <Button
        data-testid="ask-vivo-submit-button"
        className={`absolute transition-opacity h-[28px] hide-scrollbar rounded-[4px] ${
          !isSubmitDisabled
            ? "opacity-100 text-blue-500 hover:text-blue-600"
            : "opacity-50 cursor-not-allowed text-gray-400"
        }`}
        style={{
          backgroundColor: "#06709B",
          boxShadow: "none",
          width: "28px",
          bottom: "11px",
          right: "12px",
        }}
        type="primary"
        icon={
          <ArrowRightOutlined
            style={{ color: "#FFF", fontSize: "1rem", paddingTop: "5px" }}
          />
        }
        onClick={() => submitPrompt()}
        disabled={isSubmitDisabled}
      />
    </div>
  );
}
